import { Modal, ModalHeader } from "reactstrap";
import { H3, P } from "../../../../../AbstractElements";
import UpdateAddrForm from "./UpdateAddrForm";

interface ModalProps {
  ApplNo: string;
  modal: boolean;
  toggle?: () => void;
}

const UploadCandidateModal: React.FC<ModalProps> = ({
  ApplNo,
  modal,
  toggle,
}) => {
  return (
    <>
      <Modal
        size="lg"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Update Applicant Address</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">
              Review and update the applicant's address details to ensure all
              information is accurate and complete.
            </P>
          </ModalHeader>
          <UpdateAddrForm ApplNo={ApplNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default UploadCandidateModal;
